import script from "./CopyValue.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyValue.vue?vue&type=script&setup=true&lang=js"

import "./CopyValue.vue?vue&type=style&index=0&id=f896974a&lang=css"

const __exports__ = script;

export default __exports__